import React from 'react';
import FoodBudgetModule from '../modules/FoodBudgetModule';
import NutritionModule from '../modules/NutritionModule';
import SafetyModule from '../modules/SafetyModule';
import styles from '../../styles/components/layout/module-container.module.css';

interface ModuleContainerProps {
  warningCount?: Record<string, number>;
}

const ModuleContainer: React.FC<ModuleContainerProps> = ({ warningCount }) => {
  
  const handleButtonClick = (buttonId: string) => {
    console.log('Button clicked:', buttonId);
    // 后续添加具体的按钮点击处理逻辑
  };

  const handleWarningClick = () => {
    console.log('Warning link clicked');
    // 后续添加预警标准页面跳转逻辑
  };

  return (
    <section className={styles.container}>
      {/* 膳食经费模块 */}
      <div className={`${styles.module} ${styles.budget}`}>
        <FoodBudgetModule
          onButtonClick={handleButtonClick}
          onWarningClick={handleWarningClick}
          warningCount={warningCount}
        />
      </div>

      {/* 营养配餐模块 */}
      <div className={`${styles.module} ${styles.nutrition}`}>
        <NutritionModule
          onButtonClick={handleButtonClick}
          onWarningClick={handleWarningClick}
          warningCount={warningCount}
        />
      </div>

      {/* 食品安全模块 */}
      <div className={`${styles.module} ${styles.safety}`}>
        <SafetyModule
          onButtonClick={handleButtonClick}
          onWarningClick={handleWarningClick}
          warningCount={warningCount}
        />
      </div>
    </section>
  );
};

export default ModuleContainer;